import React from 'react'
import Scrollspy from 'react-scrollspy'
import Scroll from './Scroll'

const Nav = (props) => (
    <nav id="nav" className={props.sticky ? 'alt' : ''}>
        <Scrollspy items={ ['intro', 'first', 'second', 'third', 'fourth', 'fifth'] } currentClassName="is-active" offset={-300}>
            <li>
                <Scroll type="id" element="intro">
                    <a href="#">Introduction</a>
                </Scroll>
            </li>
            <li>
                <Scroll type="id" element="first">
                    <a href="#">Day 1</a>
                </Scroll>
            </li>
            <li>
                <Scroll type="id" element="second">
                    <a href="#">Day 2</a>
                </Scroll>
            </li>
            <li>
                <Scroll type="id" element="third">
                    <a href="#">Day 3</a>
                </Scroll>
            </li>
            <li>
                <Scroll type="id" element="fourth">
                    <a href="#">Day 4</a>
                </Scroll>
            </li>
            <li>
                <Scroll type="id" element="fifth">
                    <a href="#">Day 5</a>
                </Scroll>
            </li>
        </Scrollspy>
    </nav>
)

export default Nav
